module.exports = __webpack_public_path__ + "img/transformation_bg.ee01b869.png";